(ns manage.content-configuration-page.rule.db
  (:require [clojure.walk :refer [prewalk-replace]]
            [common.datascript.schema :refer [set-association]]
            [common.datascript.sequence :as dbseq]
            [common.datascript.util :as du]
            [common.ui.add-item :refer [generate-unique-id]]
            [common.ui.store :as store]
            [datascript.core :as d]
            [manage.content-configuration-page.context-source.shared
             :refer [pull-pattern-context-source]]
            [manage.content-configuration-page.placeholder-expression.db
             :refer [pull-pattern-placeholder-expression
                     value->singular-placeholder-expression]]
            [re-frame.core :as rf]
            [re-posh.core :as rp]
            [reagent.ratom :as ratom]))

(def rules (dbseq/->SequenceDB
            [:content-configuration/id "default"]
            :content-configuration/rule
            :rule/execution-order))

(def query-find-assignment
  '[:find ?phe .
    :in $ ?r ?p
    :where [?r :rule/assignment ?phe]
    [?p :placeholder/override ?phe]])

(rp/reg-query-sub :rule/find-assignment
  query-find-assignment)

(defn db-create-rule [rule]
  {:pre [(contains? rule :rule/name)]}
  (dbseq/append rules rule))

(rp/reg-event-ds :rule/create
  (fn [_ [_ rule-name]]
    (db-create-rule {:rule/name rule-name})))

(def pull-pattern-rule
  [:rule/name :rule/execution-order
   {:rule/condition
    [:macro/selector :predicate/value :predicate/operator
     {:context-source/_macro [:context-source/alias :context-source/schema]}]}
   {:rule/assignment pull-pattern-placeholder-expression}])

(rp/reg-event-ds :rule/duplicate
  (fn [ds [_ r]]
    (let [pull-pattern-rule (prewalk-replace
                             {pull-pattern-context-source [:db/id]
                              {:placeholder/_override [:placeholder/type :placeholder/name :placeholder/visualization-order]}
                              {:placeholder/_override [:db/id]}
                              {:placeholder/_override [:placeholder/type]}
                              {:placeholder/_override [:db/id]}}
                             pull-pattern-rule)
          rule (d/pull ds pull-pattern-rule r)]
      (db-create-rule (update rule :rule/name (partial generate-unique-id :rule/name))))))

(rf/reg-sub-raw :content-configuration/all-rule-assignment-options
  (fn [_ _]
    (ratom/reaction
     (doall
      (for [{p :db/id :placeholder/keys [name type]}
            (->> @(rf/subscribe [:ui.store/pull-entity [{:content-configuration/placeholder
                                                         [:placeholder/name :placeholder/type :placeholder/visualization-order]}]
                                 [:content-configuration/id "default"]])
                 :content-configuration/placeholder
                 (sort-by :placeholder/visualization-order))]
        {:value p
         :icon @(rf/subscribe [:placeholder/icon type])
         :label name})))))

(rf/reg-sub :rule/query-params
  (fn [[_ rule _new-rule-name]]
    (store/get-value rule :rule/name))
  (fn [rule-name [_ _rule new-rule-name]]
    {:menu :rules
     :entity :rule
     :name (or new-rule-name rule-name)}))

(rp/reg-query-sub ::assigned-placeholders
  '[:find ?o ?phe ?p
    :in $ ?r
    :where
    [?r :rule/assignment ?phe]
    [?p :placeholder/override ?phe]
    [?p :placeholder/visualization-order ?o]])

(defn assignment [r p value]
  (set-association :placeholder-expression
                   {:placeholder/_override p
                    :rule/_assignment r}
                   value))

(rp/reg-event-ds :rule/sync-assignments
  (fn [ds [_ r assigned to-be-assignments]]
    (du/sync-many
     r :rule/assignment
     (map (partial take-last 2) assigned)
     to-be-assignments
     (fn [p]
       (let [type (-> (d/datoms ds :eavt p :placeholder/type) first :v)]
         (assignment
          r p
          (when-not (= type :collection)
            (value->singular-placeholder-expression ds ""))))))))
